import { ModalEndDraft } from './ModalEndDraft';

export default ModalEndDraft;
